export default function TariffValidationResult({ validation }) {
  if (!validation) {
    return null;
  }

  return (
    <section className="card tariff-import-card">
      <div className="section-head">
        <div>
          <h2>5. Plausibilitaetspruefung</h2>
          <p className="section-text">
            {validation.ok ? "Der Tarif kann gespeichert werden." : "Bitte Fehler vor dem Speichern beheben."}
          </p>
        </div>
        <span className={`tariff-status-pill ${validation.ok ? "tariff-status-ok" : "tariff-status-error"}`}>
          {validation.ok ? "Gueltig" : "Fehler"}
        </span>
      </div>

      {validation.errors.length > 0 && (
        <div className="message message-error">
          {validation.errors.slice(0, 20).map((error) => (
            <div key={error}>{error}</div>
          ))}
          {validation.errors.length > 20 && <div>Weitere Fehler vorhanden.</div>}
        </div>
      )}

      {validation.warnings.length > 0 && (
        <div className="message message-info">
          {validation.warnings.map((warning) => (
            <div key={warning}>{warning}</div>
          ))}
        </div>
      )}
    </section>
  );
}
